import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Agreement, ButtonsRow, Paragraph, } from "~/client/components/AgreementRequired/styled";
import Button from "~/client/components/Button";
import Checkbox from "~/client/components/Checkbox";
import Interstitial from "~/client/components/Interstitial";
import { useUserAgreed } from "~/client/storage";
const AgreementRequired = ({ children }) => {
    const [userAgreed, setUserAgreed] = useUserAgreed();
    const [isChecked, setIsChecked] = useState(false);
    if (userAgreed === false) {
        return (_jsxs(Interstitial, { children: [_jsx(Paragraph, { children: "Welcome to Tiny Recipe Box!" }), _jsx(Paragraph, { children: "This site is still in development and no existing functionality is guaranteed to work when a new version is released. Use this site at your own risk." }), _jsxs(Agreement, { children: [_jsx(Checkbox, { "data-testid": "agreement-checkbox", isSelected: isChecked, onChange: setIsChecked }), " ", "I understand and accept the risk"] }), _jsx(ButtonsRow, { children: _jsx(Button, { "data-testid": "agreement-submit", isDisabled: isChecked !== true, onPress: () => {
                            setUserAgreed(true);
                        }, children: "Enter" }) })] }));
    }
    return children;
};
export default AgreementRequired;
